<template>
  <FormInput
    class="FormPriceInput"
    content-wrapper-class="d-flex"

    v-bind="{...$attrs, ...$props}"
    v-on="$listeners"
  >
    <span class="currency-wrapper d-flex justify-content-center align-items-center flex-shrink-0">
      €
    </span>
  </FormInput>
</template>

<script>

import FormInput from "./FormInput.vue"

import { props } from "./FormFieldWrapper.vue"

export default {
  props: {
    ...props,
  },
  components: {
    FormInput,
  },
}

</script>

<style scoped>

.currency-wrapper {
  background-color: #F6F6F6;
  width: 35px;
  border-right: none;
  border-radius: 3px 0 0 3px;
  border-width: 1px 0 1px 1px;
  border-style: solid;
  border-color: #E3E3E3;
}

</style>

<style>

.FormPriceInput input {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

</style>
